import React from 'react';
import AdminSidebarLink from './AdminSidebarLink';

interface SidebarLinkData {
  icon: string;
  text: string;
  isActive?: boolean;
  onClick?: () => void;
  link?: string;
}

interface AdminSidebarSectionProps {
  title: string;
  links: SidebarLinkData[];
  id?: string;
}

const AdminSidebarSection: React.FC<AdminSidebarSectionProps> = ({ 
  title, 
  links, 
  id 
}) => {
  return (
    <div id={id} className="mb-6">
      <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-3">
        {title}
      </h3>
      <ul className="space-y-2">
        {links.map((link, index) => (
          <AdminSidebarLink
            key={index}
            icon={link.icon}
            text={link.text}
            isActive={link.isActive}
            onClick={link.onClick}
            link={link.link}
          />
        ))}
      </ul>
    </div>
  );
};

export default AdminSidebarSection;
